export const TIMEZONE_RADIO_TYPES = {
  local: 'local',
  portal: 'portal',
  userObject: 'userObject'
};